<template>
  <NuxtPage />
  <!-- 确认按钮弹出框-授权 -->
  <!-- <DialogAuthConfirm /> -->
  <!-- 充值提示弹窗 -->
  <!-- <RechargeTipsPopup /> -->
  <!-- 免费券弹窗 -->
  <!-- <FreeCardPopup /> -->
  <!-- 充值弹窗 -->
  <!-- <RechargePopup /> -->
  <!-- webView -->
  <!-- <WebViewPopup /> -->
  <!-- 下载App提示弹窗 -->
  <!-- <DownloadAppTipsPopup /> -->
  <!-- 登录弹窗 -->
  <!-- <Login /> -->
  <!-- 主动拨打电话等待中 -->
  <!-- <CallWaitingPopup /> -->
  <!-- 用户信息弹窗 -->
  <!-- <UserInfoPopup /> -->
  <!-- 电话接听 -->
  <!-- <CallAcceptPopup /> -->
  <!-- 文本为SEO使用，请忽略 -->
  <!-- <div class="description-content">
    Leeski Meet video chat with new people online ✔️1V1 video calls ✔️1v1 chats
    ✔️ make new friends ✔️ find your next date. In Leeski, you can choose
    someone for video dating, enjoy a sweet relationship, and accompany you to
    eliminate loneliness and worries. You will have a wonderful time.
  </div> -->
</template>

<script setup lang="ts">
// import qs from 'qs'
import '@vant/touch-emulator' // 桌面端适配,将 mouse 事件转换成对应的 touch 事件
// import RechargePopup from '@/pages/Recharge/components/RechargePopup.vue'

// const AsyncRechargePopup = defineAsyncComponent(
//   () => import('@/pages/Recharge/components/RechargePopup.vue')
// )
// const publicStore = usePublicStore()
// const userStore = useUserStore()
// const loginStore = useLoginStore()

// 语言初始化
const languageStore = useLanguageStore()
languageStore.initLanguage()
// 监听路由，切换页面动态设置SEOMeta
// const router = useRouter()
// const route = useRoute()
// router.afterEach(() => {
//   // 加定时器是想延迟跳转到目标页面再设置
//   setTimeout(() => {
//     usePrivateSeoMeta()
//   }, 0)
// })
// usePrivateSeoMeta() // 刷新页面不会触发路由监听，所以主动调一次

// 浏览器  client端才会走的逻辑
// if (process.client) {
// localStorage.removeItem('login') // 1.1.4 2024-07-30 用于移除弃用缓存
// localStorage.removeItem('language') // 1.1.4 2024-07-30 用于移除弃用缓存

// 初始化登录
// if (route.path.indexOf('/roomApp/') !== -1 && common.checkVersion().app) {
// 在客户端打开房，逻辑性逻辑在语音房使用
// } else {
// 初始化登录
// loginStore.initLogin()
/** 显示与隐藏页面的hooks，存到public store */
// usePageVisibility((isVisible) => {
//   publicStore.setIsPageVisible(isVisible)
//   // 网页切换到后台或者手机处于息屏状态监听
//   if (localStorage.getItem('ticket') && localStorage.getItem('loginInfo')) {
//     if (document.hidden) {
//       userStore.changeManOnline(2) // 标志下线
//     } else {
//       userStore.changeManOnline(1) // 标志上线
//     }
//   }
// })
/**
 * 链接带参进入
 * &source=来源
 * &country=国家代码
 * */
/**
 * 链接带参进入
 * &utm_campaign=广告系列ID
 * &country=国家代码
 * */
// 如果url有国家代码进来就作为默认国家。
// 有时候推广会传国家代码以外的值进来，这种直接忽略，目前有 allcountry
// const country = common.getQueryVariable('country')
// if (country && country !== 'allcountry') {
//   loginStore.setUTMCountry(country)
// }
// 如果有广告系列ID进来，就存到pinia，然后重定向此页面
// const utmCampaign = common.getQueryVariable('utm_campaign')
// if (utmCampaign) {
//   loginStore.setUTMCampaign(utmCampaign)
// }
// 存投放参数,如果当前有UTM广告参数就存在缓存，谷歌重定向回来再拼接重定向
// if (/country|utm_campaign/.test(location.search)) {
//   localStorage.setItem('utmCampaignSearch', location.search)
// }
//  谷歌重定向登录成功回来走流程
// if (/code|token/.test(location.hash)) {
//   // 执行谷歌回调登录时间
//   const loginData = qs.parse(location.hash)
//   loginStore.googleLoign(loginData)
//   // 执行重定向流程，utmCampaignSearch 是广告参数，是在谷歌登录之前存的，重定向回来拼接回去
//   const utmCampaignSearch = localStorage.getItem('utmCampaignSearch') || ''
//   utmCampaignSearch && localStorage.removeItem('utmCampaignSearch')
//   const router = useRouter()
//   router.replace('/' + utmCampaignSearch)
// }
// 获取到UDID重定向回来 && 并且是safari浏览器
// const iosUDID = common.getQueryVariable('UDID')
// if (common.checkVersion().safari && iosUDID) {
//   publicStore.setIOSUDID(iosUDID)
//   // 执行重定向流程，utmCampaignSearch 是广告参数，是在谷歌登录之前存的，重定向回来拼接回去
//   const utmCampaignSearch = localStorage.getItem('utmCampaignSearch') || ''
//   utmCampaignSearch && localStorage.removeItem('utmCampaignSearch')
//   const router = useRouter()
//   router.replace('/' + utmCampaignSearch)
// }
// 本地环境自动加UDID
// if (useRuntimeConfig().public.appMode === 'development') {
//   publicStore.setIOSUDID('00008030-001E29493EF2802E')
// }
// }
// }

// onBeforeUnmount(() => {
//   // socketStore.inSocket && socketStore.inSocket.destroy()
// })
</script>

<style></style>
